var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.account
    ? _c("div", { staticClass: "el-core__header__left" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.clickedOutside,
                expression: "clickedOutside",
              },
            ],
            ref: "appContext",
            staticClass: "emd-control",
            class: [
              ((_obj = {}),
              (_obj["_status_" + _vm.status.key] = _vm.status),
              _obj),
              { _open: _vm.showAccountList },
            ],
          },
          [
            _c(
              "div",
              { staticClass: "emd-control__wrapper" },
              [
                _vm.status
                  ? _c("span", { staticClass: "emd-control__status" }, [
                      _vm._v(_vm._s(_vm.status.value)),
                    ])
                  : _vm._e(),
                _vm._m(0),
                _c("div", { staticClass: "emd-control__text" }, [
                  _c(
                    "a",
                    {
                      staticClass: "emd-control__text__item",
                      attrs: {
                        href: _vm.urlCompany,
                        title: _vm.merchant.name,
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                    [_vm._v(_vm._s(_vm.merchant.name))]
                  ),
                  _c("h2", { staticClass: "emd-control__text__item" }, [
                    _vm._v(_vm._s(_vm.accountName)),
                  ]),
                ]),
                _c(
                  "emd-tippy",
                  {
                    staticClass: "_no-wrap",
                    attrs: {
                      id: "account",
                      type: "ghost",
                      position: "left",
                      content: _vm.$t("tooltip.account"),
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "emd-action-button _has-tooltip _type_ghost",
                        on: { click: _vm.toggleAccountList },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "emd-action-button__icon uil uil-exchange",
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "emd-control__dropdown" },
              [_vm.showAccountList ? _c("app-context-select") : _vm._e()],
              1
            ),
          ]
        ),
        _c(
          "div",
          { staticClass: "eu-ml_4 eu-display_none eu-display_block_md" },
          [
            _c(
              "div",
              { staticClass: "emd-logo-custom" },
              [_c("logo-stone-rebrand", { staticClass: "logo-pgm" })],
              1
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "emd-control__icon" }, [
      _c("i", { staticClass: "uil uil-store" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }